export default __webpack_public_path__ + "static/media/start-2.4f321e14.jpg";